nodeMarquee({
  parent: '.main_announcement',
  speed: 1
});


nodeMarquee({
  parent: '.marquee_home',
  speed: 1
});


    nodeMarquee({
  parent: '.marquee_product',
  speed: 1
});

    nodeMarquee({
  parent: '.new_home_logo',
  speed: 1.2
});
    nodeMarquee({
  parent: '.new_home_logo_new',
  speed: 1.2
  
});
    nodeMarquee({
  parent: '.new_home_logo_call_1',
  speed: 1.2
  
});